import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@fastnorth/kraken/components/card';
import { Cerbicon } from '@fastnorth/kraken/components/image';
import { Flex } from '@fastnorth/kraken/components/layout';
import { H1, Text } from '@fastnorth/kraken/components/typography';
import getEnvFromHostname from '../../utils/getEnvFromHostname';

type GeneralErrorProps = {
  id?: string;
  error?: Error;
  title?: string;
  message?: string;
};

const GeneralError = ({ error, message, title, id }: GeneralErrorProps): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.error_ui' });
  return (
    <Card id={id} data-testid={id}>
      <Flex className={'justify-center items-center flex-col'}>
        <Cerbicon
          variant={'illustration'}
          src={'https://cdn.raceroster.com/assets/cerbicons/empty-500.svg'}
          alt={'error image'}
        />
        <Flex className={`flex-col justify-center items-center flex-wrap`}>
          <H1>{title || t('oops')}</H1>
          <Text>{message || t('error_generic_message')}</Text>
          {error?.message && <Text spacing={'4 0 0'}>{error.message}</Text>}
          {getEnvFromHostname() === 'local' && error?.stack && (
            <Text spacing={'4 0 0'}>
              <code>{error.stack}</code>
            </Text>
          )}
        </Flex>
      </Flex>
    </Card>
  );
};

export default GeneralError;
